import { SaveSingleColorButton } from "./save-single-color-button";
import { useMyLikedColorsStore } from "../../../js/stores/my-liked-colors-store";
import { useSaveSingleColor } from "../../save-single-color";

export function LikedButton() {
  const { colorCode } = useSaveSingleColor();
  const isLikedStoreReady = useMyLikedColorsStore(
    (state) => state._hasHydrated
  );
  const likedColors = useMyLikedColorsStore((state) => state.likedColors);
  const addColor = useMyLikedColorsStore((state) => state.addColor);
  const removeColor = useMyLikedColorsStore((state) => state.removeColor);
  const isColorLiked = likedColors.includes(colorCode);
  const toggleClickHandler = () => {
    if (isColorLiked) {
      removeColor(colorCode);
    } else {
      addColor(colorCode);
    }
  };

  return (
    <div>
      {isLikedStoreReady && (
        <SaveSingleColorButton
          isSaved={isColorLiked}
          toggleClickHandler={toggleClickHandler}
        />
      )}
    </div>
  );
}
